import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface HamburgerMenuProps extends IconProps {
  color?: TIconColor;
}

const HamburgerMenu = ({ size, variant, className, color = 'white' }: HamburgerMenuProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 3.5C1.5 3.08579 1.83579 2.75 2.25 2.75H13.75C14.1642 2.75 14.5 3.08579 14.5 3.5C14.5 3.91421 14.1642 4.25 13.75 4.25H2.25C1.83579 4.25 1.5 3.91421 1.5 3.5ZM1.5 8C1.5 7.58579 1.83579 7.25 2.25 7.25H13.75C14.1642 7.25 14.5 7.58579 14.5 8C14.5 8.41421 14.1642 8.75 13.75 8.75H2.25C1.83579 8.75 1.5 8.41421 1.5 8ZM1.5 12.5C1.5 12.0858 1.83579 11.75 2.25 11.75H13.75C14.1642 11.75 14.5 12.0858 14.5 12.5C14.5 12.9142 14.1642 13.25 13.75 13.25H2.25C1.83579 13.25 1.5 12.9142 1.5 12.5Z"
      fill="currentColor"
    />
  </svg>
);

export default HamburgerMenu;
